import { TwicPicture as BaseTwicPicture } from "@twicpics/components/react";
import { styled } from "src/ccl/stitches";

export const TwicPicture = styled(BaseTwicPicture, {});
